import { makeStyles, Theme } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';

import { ReactComponent as ActiveMarkSvg } from '../../../assets/know_each_other/active_mark.svg';
import { ReactComponent as CheckSvg } from '../../../assets/know_each_other/check.svg';
import { OnboardingStep } from '../../../graphql/gen/types';
import { colorPalette } from '../../../theme';
import { ButtonColor, PlexButton } from '../../shared/primitives/PlexButton';

interface Props {
  changeOnboardingStep: (step: OnboardingStep) => void;
  completedOnboardingSteps: OnboardingStep[];
  currentStep: OnboardingStep;
}

export const OnboardingStepSelector = ({
  changeOnboardingStep,
  completedOnboardingSteps,
  currentStep,
}: Props): React.ReactElement => {
  const classes = useStyles();

  const buttons = [
    {
      label: 'Tell Us About You',
      step: OnboardingStep.GetStarted,
    },
    {
      label: 'Get Plugged Into Plex',
      step: OnboardingStep.GetPluggedIntoPlex,
    },
    {
      label: "Let's Get To Know Each Other",
      step: OnboardingStep.KnowEachOther,
    },
  ];
  return (
    <div className={classes.root}>
      {buttons.map((buttonData, index) => {
        const onClick = buttonData.step !== currentStep ? (): void => changeOnboardingStep(buttonData.step) : undefined;
        if (buttonData.step === currentStep) {
          return (
            <PlexButton
              className={classes.buttonContainer}
              label={
                <div className={classes.buttonLabel}>
                  <ActiveMarkSvg />
                  <span className={classNames(classes.icon, classes.indexNumber, classes.indexNumberActive)}>
                    {index + 1}
                  </span>
                  <span>{buttonData.label}</span>
                </div>
              }
              onClick={onClick}
              color={ButtonColor.TransparentBlue}
            />
          );
        }
        if (completedOnboardingSteps.indexOf(buttonData.step) !== -1) {
          return (
            <PlexButton
              className={classes.buttonContainer}
              label={
                <div className={classes.buttonLabel}>
                  <CheckSvg className={classes.icon} />
                  <span>{buttonData.label}</span>
                </div>
              }
              onClick={onClick}
              color={ButtonColor.TransparentGrayLight}
            />
          );
        }
        return (
          <PlexButton
            className={classes.buttonContainer}
            label={
              <div className={classes.buttonLabel}>
                <span className={classNames(classes.icon, classes.indexNumber)}>{index + 1}</span>
                <span>{buttonData.label}</span>
              </div>
            }
            onClick={onClick}
            color={ButtonColor.TransparentGray}
          />
        );
      })}
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  indexNumber: {
    display: 'flex',
    height: 24,
    width: 24,
    backgroundColor: colorPalette.purpleGray._400,
    borderRadius: 12,
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 14,
    lineHeight: '24px',
    color: '#fff',
  },
  indexNumberActive: {
    backgroundColor: colorPalette.primaryColorBlue.primary,
    marginLeft: '32px !important', // overwrite icon classname
  },
  icon: {
    marginRight: 20,
    marginLeft: 37,
  },
  buttonContainer: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    borderRadius: 4,
    paddingLeft: 0,
    paddingRight: 0,
  },
  buttonLabel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
}));
